export default __webpack_public_path__ + "static/media/bsw.d90ec4b5.svg";